"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

const tabs = [
  { label: "Beranda", hash: "", path: "m3 10 9-7 9 7M5 9v11h5v-6h4v6h5V9" },
  { label: "Cari", hash: "search", path: "M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0" },
  { label: "Platform", hash: "platform", path: "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z" },
];

export function MobileNav() {
  const pathname = usePathname();
  const [active, setActive] = useState("");
  useEffect(() => {
    const update = () => setActive(window.location.hash.slice(1));
    update();
    window.addEventListener("hashchange", update);
    return () => window.removeEventListener("hashchange", update);
  }, [pathname]);

  return <nav className="mobile-nav" aria-label="Navigasi utama mobile">
    {tabs.map((tab) => <Link key={tab.label} href={`/${tab.hash ? `#${tab.hash}` : ""}`} prefetch={false}
      aria-current={pathname === "/" && active === tab.hash ? "page" : undefined}
      onClick={(event) => {
        if (pathname !== "/") return;
        event.preventDefault();
        window.history.replaceState(null, "", tab.hash ? `/#${tab.hash}` : "/");
        setActive(tab.hash);
        window.dispatchEvent(new HashChangeEvent("hashchange"));
        if (!tab.hash) window.scrollTo({ top: 0 });
      }}>
      <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={tab.path} /></svg></span>
      <span>{tab.label}</span>
    </Link>)}
  </nav>;
}

